import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { EntityCommandTypeEnum } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityManager } from "@seriously-rad/seriouslyrad-framework-core/EntityManager";
import { JNativeStatic } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { registerCoreAsync, registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { FullPageLoader } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/FullPageLoader";
import { registerModuleContactsAsync } from "@seriously-rad/seriouslyrad-framework-module-contacts/Registration";
import { registerModuleDocumentsAsync } from "@seriously-rad/seriouslyrad-framework-module-documents/Registration";
import { registerModuleFilesAsync } from "@seriously-rad/seriouslyrad-framework-module-files/Registration";
import { registerModuleIntegrationsAsync } from "@seriously-rad/seriouslyrad-framework-module-integrations/Registration";
import { registerModuleJobsAsync } from "@seriously-rad/seriouslyrad-framework-module-jobs/Registration";
import { registerModuleNotificationsAsync } from "@seriously-rad/seriouslyrad-framework-module-notifications/Registration";
import { registerModuleProcessesAsync } from "@seriously-rad/seriouslyrad-framework-module-processes/Registration";
import { registerModuleReportsAsync } from "@seriously-rad/seriouslyrad-framework-module-reports/Registration";
import { EntityCommandProcessStartProcessTest } from "./EntityCommands/EntityCommandProcessStartProcessTest";
import { EntityCommandTeamMemberRemoveFromTeam } from "./EntityCommands/EntityCommandTeamMemberRemoveFromTeam";
import { EntityCommandUserDelete } from "./EntityCommands/EntityCommandUserDelete";
import { EntityCommandUserSetPassword } from "./EntityCommands/EntityCommandUserSetPassword";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

const
    radWindow = WindowShim();

export async function registerAppAsync(configuration: Configuration)
{
    radWindow.entityManager = new EntityManager();
    radWindow.fullPageLoader = new FullPageLoader();

    await registerCoreAsync(configuration);
    await registerModuleContactsAsync(configuration);
    await registerModuleDocumentsAsync(configuration);
    await registerModuleFilesAsync(configuration);
    await registerModuleIntegrationsAsync(configuration);
    await registerModuleJobsAsync(configuration);
    await registerModuleNotificationsAsync(configuration);
    await registerModuleProcessesAsync(configuration);
    await registerModuleReportsAsync(configuration);

    JNativeStatic.ajaxSetup({
        timeout: null
    });

    radWindow.entityManager.registerCommand(new EntityCommandProcessStartProcessTest());
    radWindow.entityManager.removeCommand({ entityName: "TeamMember", key: "DELETE", type: EntityCommandTypeEnum.entity });
    radWindow.entityManager.registerCommand(new EntityCommandTeamMemberRemoveFromTeam());
    radWindow.entityManager.registerCommand(new EntityCommandUserDelete());
    radWindow.entityManager.registerCommand(new EntityCommandUserSetPassword());

    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}